import { ApiKeyFields } from "types";

export const checkFieldPropType = (value: ApiKeyFields[] | boolean, exclude: ApiKeyFields[] | undefined, field: ApiKeyFields) => {
  const isFieldExcluded = exclude?.includes(field) || false;
  if (typeof value === "boolean") {
    return isFieldExcluded ? !value : value;
  }
  return isFieldExcluded ? false : value.includes(field);
};
